import { FocusArea } from 'libs/end-to-end/src/focus-area';

export const SideNavigationMenuCollapsedCacheKey =
  'side-navigation-menu-collapsed';
export const IdTokenCacheKey = 'idToken';
export const RefreshTokenCacheKey = 'refreshToken';

export const focusAreaPersistedMetricCacheKey = ({
  focusArea,
  page,
  webCacheKeyPrefix,
}: {
  focusArea: string;
  page:
    | 'group-trends'
    | 'disparity-and-optimization'
    | 'overview'
    // Basically overview v2
    | 'summary'
    | 'success-phenotype-v2';
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-focusAreaPersistedMetricCacheKey-${focusArea}-${page}`;
};

export const focusAreaPersistedDimensionCacheKey = ({
  focusArea,
  page,
  webCacheKeyPrefix,
}: {
  focusArea: string;
  page: 'group-trends' | 'disparity-and-optimization';
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-focusAreaPersistedDimensionCacheKey-${focusArea}-${page}`;
};

export const focusAreaPersistedFilterCacheKey = ({
  focusArea,
  page,
  webCacheKeyPrefix,
}: {
  focusArea: string;
  page:
    | 'group-trends'
    | 'disparity-and-optimization'
    | 'overview'
    // Basically overview v2
    | 'summary';
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-focusAreaPersistedFilterCacheKey-${focusArea}-${page}`;
};

export const pipelineAnalysisPersistedDimensionCacheKey = ({
  webCacheKeyPrefix,
}: {
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-pipelineAnalysisPersistedDimensionCacheKey`;
};

export const pipelineAnalysisPersistedFilterCacheKey = ({
  webCacheKeyPrefix,
}: {
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-pipelineAnalysisPersistedFilterCacheKey`;
};

export const allInsightsFocusAreaPersistedDimensionCacheKey = ({
  focusArea,
  webCacheKeyPrefix,
}: {
  focusArea: FocusArea;
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-allInsightsFocusAreaPersistedDimensionCacheKey-${focusArea}`;
};

export const payCorrectionPersistedMetricCacheKey = ({
  webCacheKeyPrefix,
}: {
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-payCorrectionPersistedMetricCacheKey`;
};

export const overviewPagePersistedMetricCacheKey = ({
  component,
  webCacheKeyPrefix,
}: {
  component:
    | 'top-skills-by-role'
    | 'metrics-to-focus-on'
    | 'optimization-of-skills-and-competancies';
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-overviewPagePersistedMetricCacheKey-${component}`;
};

export const overviewPagePersistedFilterCacheKey = ({
  component,
  webCacheKeyPrefix,
}: {
  component: 'top-skills-by-role' | 'optimization-of-skills-and-competancies';
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-overviewPagePersistedFilterCacheKey-${component}`;
};

export const hiringCopilotCustomVizCacheKey = ({
  webCacheKeyPrefix,
}: {
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-hiringCopilotCustomVizCacheKey`;
};

export const promotionCopilotCustomVizCacheKey = ({
  webCacheKeyPrefix,
}: {
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-promotionCopilotCustomVizCacheKey`;
};

export const successPhenotypeV2CustomVizCacheKey = ({
  webCacheKeyPrefix,
}: {
  webCacheKeyPrefix: string;
}) => {
  return `${webCacheKeyPrefix}-successPhenotypeV2CustomVizCacheKey`;
};
